import { AxiosResponse } from 'axios';
import apiClient from './client';
import {
  CommunicationDto,
  CommunicationCreateRequestDto,
  CommunicationUpdateRequestDto,
  CommunicationSearchParams,
  mapCommunicationSearchParams,
} from '../interfaces/communication';
import { PageResultDto } from '../interfaces/page';
import { ApiResponseDto } from '../interfaces/apiResponse';

interface CommunicationsService {
  search(params: CommunicationSearchParams): Promise<PageResultDto<CommunicationDto>>;
  getById(id: number): Promise<CommunicationDto>;
  create(request: CommunicationCreateRequestDto): Promise<CommunicationDto>;
  update(id: number, request: CommunicationUpdateRequestDto): Promise<CommunicationDto>;
  delete(id: number): Promise<void>;
}

const endpoints = {
  base: '/communications',
  byId: (id: number) => `/communications/${id}`,
};

export const communicationsService: CommunicationsService = {
  search: async (params: CommunicationSearchParams): Promise<PageResultDto<CommunicationDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<CommunicationDto>>> = await apiClient.get(endpoints.base, {
      params: mapCommunicationSearchParams(params),
    });

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  getById: async (id: number): Promise<CommunicationDto> => {
    const response: AxiosResponse<ApiResponseDto<CommunicationDto>> = await apiClient.get(endpoints.byId(id));

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  create: async (request: CommunicationCreateRequestDto): Promise<CommunicationDto> => {
    const response: AxiosResponse<ApiResponseDto<CommunicationDto>> = await apiClient.post(endpoints.base, request);

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  update: async (id: number, request: CommunicationUpdateRequestDto): Promise<CommunicationDto> => {
    const response: AxiosResponse<ApiResponseDto<CommunicationDto>> = await apiClient.put(endpoints.byId(id), request);

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(endpoints.byId(id));
  },
};
